/** Builds a scannable UPI QR image URL. Shared by the counter QR and the subscription payment page. */
export function upiQrUrl(upiId: string, payeeName: string, size = 160): string {
  const payload = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(payeeName)}&cu=INR`;
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(payload)}`;
}
